// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dtP9-","col":"styles_col__13UX3"};